import React from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Chip,
  Grid,
} from '@mui/material';
import {
  CloudUpload,
  InsertDriveFile,
  CheckCircle,
  Error,
} from '@mui/icons-material';

const DocumentUpload = ({ title, description, status }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
    maxSize: 5000000, // 5MB
  });

  const getStatusChip = () => {
    switch (status) {
      case 'validated':
        return (
          <Chip
            icon={<CheckCircle fontSize="small" />}
            label="Validé"
            color="success"
            size="small"
          />
        );
      case 'error':
        return (
          <Chip
            icon={<Error fontSize="small" />}
            label="Refusé"
            color="error"
            size="small"
          />
        );
      default:
        return (
          <Chip
            icon={<CloudUpload fontSize="small" />}
            label="À téléverser"
            color="primary"
            size="small"
          />
        );
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">{title}</Typography>
        {getStatusChip()}
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      <Box
        {...getRootProps()}
        sx={{
          border: '2px dashed #ccc',
          borderRadius: 1,
          p: 3,
          textAlign: 'center',
          cursor: 'pointer',
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}
      >
        <input {...getInputProps()} />
        <CloudUpload sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
        <Typography>
          Glissez-déposez votre fichier ici ou cliquez pour sélectionner
        </Typography>
        <Typography variant="body2" color="text.secondary">
          PDF, JPEG ou PNG • Max 5 Mo
        </Typography>
      </Box>
    </Paper>
  );
};

const Justificatifs = () => {
  const documents = [
    {
      title: 'Pièce d\'identité',
      description: 'Carte d\'identité, passeport ou titre de séjour en cours de validité',
      status: 'validated',
    },
    {
      title: 'Justificatif de domicile',
      description: 'Facture d\'électricité, gaz, internet de moins de 3 mois',
      status: 'error',
    },
    {
      title: 'RIB professionnel',
      description: 'Relevé d\'identité bancaire au nom de votre société',
      status: null,
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Justificatifs
      </Typography>
      <Grid container spacing={2}>
        {documents.map((doc, index) => (
          <Grid item xs={12} key={index}>
            <DocumentUpload {...doc} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Justificatifs; 